// Translation dictionary for Småstund
export const translations = {
  no: {
    // Brand
    brand_tagline: "Digitale ressurser for foreldre og barn",

    // Navigation
    nav_home: "Hjem",
    nav_shop: "Butikk",
    nav_about: "Om oss",
    nav_contact: "Kontakt",
    nav_cart: "Handlekurv",

    // Hero
    hero_eyebrow: "Designet av en sertifisert barnepedagog",
    hero_title_1: "Vakre digitale",
    hero_title_2: "ressurser",
    hero_title_3: "for hverdagen",
    hero_subtitle:
      "Skrivbare PDF-er som hjelper foreldre med å skape rolige rutiner, lærerike aktiviteter og minnerike stunder med barna.",
    hero_cta_shop: "Utforsk butikken",
    hero_cta_learn: "Lær mer",

    // Features bar
    feat_1: "Umiddelbar nedlasting",
    feat_2: "Betal sikkert med Stripe",
    feat_3: "Laget av pedagog",
    feat_4: "Skrivbar A4",

    // Sections
    featured_eyebrow: "Utvalgte ressurser",
    featured_title: "Våre mest elskede produkter",
    featured_sub: "Håndplukket samling for å gjøre hverdagen din vakrere",
    shop_all: "Se alle produkter",

    categories_eyebrow: "Kategorier",
    categories_title: "Finn det som passer barnet ditt",

    about_eyebrow: "Om Småstund",
    about_title: "Skapt med kjærlighet og fagkunnskap",
    about_text:
      "Småstund er bygget på 15+ års erfaring som barnepedagog. Hver ressurs er designet for å gi foreldre mer trygghet, og barna mer glede. Vi tror på enkle, vakre løsninger som faktisk fungerer i en travel hverdag.",
    about_point_1: "Pedagogisk fundert innhold",
    about_point_2: "Skrivbare PDF-er i høy kvalitet",
    about_point_3: "Testet med ekte familier",

    cta_title: "Klar til å skape mer ro i familien?",
    cta_sub: "Få 10% rabatt på første kjøp når du melder deg på nyhetsbrevet vårt.",
    cta_email: "Din e-postadresse",
    cta_button: "Meld meg på",
    cta_thanks: "Takk! Du er nå påmeldt.",

    // Product
    product_price: "Pris",
    product_pages: "sider",
    product_format: "PDF • Umiddelbar nedlasting",
    product_add_cart: "Legg i handlekurv",
    product_in_cart: "I handlekurv",
    product_about: "Om dette produktet",
    product_related: "Andre liker også",

    // Cart
    cart_title: "Handlekurv",
    cart_empty: "Handlekurven er tom",
    cart_continue: "Fortsett å handle",
    cart_subtotal: "Subtotal",
    cart_total: "Totalt",
    cart_checkout: "Til kassen",
    cart_remove: "Fjern",
    cart_qty: "Antall",

    // Checkout
    checkout_title: "Fullfør bestilling",
    checkout_email: "E-postadresse",
    checkout_email_help: "Vi sender PDF-ene til denne adressen",
    checkout_name: "Navn (valgfritt)",
    checkout_pay: "Betal nå",
    checkout_secure: "Sikker betaling med Stripe",

    // Success
    success_title: "Tusen takk!",
    success_sub: "Bestillingen din er bekreftet",
    success_email: "Vi har sendt nedlastingslenker til:",
    success_download: "Last ned dine produkter",
    success_continue: "Tilbake til butikken",
    success_processing: "Behandler betalingen...",
    success_failed: "Noe gikk galt. Vennligst prøv igjen.",

    // Footer
    footer_tagline: "Vakre digitale ressurser for hverdagen",
    footer_quick: "Hurtiglenker",
    footer_legal: "Juridisk",
    footer_privacy: "Personvern",
    footer_terms: "Vilkår",
    footer_refund: "Refusjon",
    footer_rights: "Alle rettigheter forbeholdt",

    // Chat
    chat_title: "Hei! Kan jeg hjelpe deg?",
    chat_placeholder: "Skriv en melding...",
    chat_send: "Send",
    chat_welcome: "Hei! Jeg er Småstund-assistenten. Hvordan kan jeg hjelpe deg i dag?",

    // Categories
    cat_smabarn: "Småbarn",
    cat_skolebarn: "Skolebarn",
    cat_aktiviteter: "Aktiviteter",
    cat_oppskrifter: "Oppskrifter",
    cat_tospraklig: "Tospråklig",
    cat_foreldre: "Foreldre",
    cat_all: "Alle",

    // Bundles
    bundles_eyebrow: "Spar med pakker",
    bundles_title: "Ressurser i pakker — gode tilbud",
    bundles_sub: "Sett sammen for å spare deg tid og penger",
    bundle_save: "Spar",
    bundle_includes: "Inkluderer",
    bundle_products: "produkter",
    bundle_value: "Verdi",
    bundle_view_all: "Se alle pakker",
    bundle_add_cart: "Legg pakken i kurv",
    bundle_in_cart: "Pakken er i kurv",

    // Common
    loading: "Laster...",
    currency: "NOK",
  },
  en: {
    // Brand
    brand_tagline: "Digital resources for parents and children",

    // Navigation
    nav_home: "Home",
    nav_shop: "Shop",
    nav_about: "About",
    nav_contact: "Contact",
    nav_cart: "Cart",

    // Hero
    hero_eyebrow: "Designed by a certified child educator",
    hero_title_1: "Beautiful digital",
    hero_title_2: "resources",
    hero_title_3: "for everyday life",
    hero_subtitle:
      "Printable PDFs that help parents create calm routines, educational activities, and memorable moments with their children.",
    hero_cta_shop: "Explore the shop",
    hero_cta_learn: "Learn more",

    // Features bar
    feat_1: "Instant download",
    feat_2: "Secure Stripe payment",
    feat_3: "Made by educator",
    feat_4: "Printable A4",

    // Sections
    featured_eyebrow: "Featured resources",
    featured_title: "Our most loved products",
    featured_sub: "A handpicked collection to make your everyday more beautiful",
    shop_all: "View all products",

    categories_eyebrow: "Categories",
    categories_title: "Find what fits your child",

    about_eyebrow: "About Småstund",
    about_title: "Made with love and expertise",
    about_text:
      "Småstund is built on 15+ years of experience as a child educator. Every resource is designed to give parents more confidence, and children more joy. We believe in simple, beautiful solutions that actually work in a busy day.",
    about_point_1: "Pedagogically grounded content",
    about_point_2: "High-quality printable PDFs",
    about_point_3: "Tested with real families",

    cta_title: "Ready to bring more calm to your family?",
    cta_sub: "Get 10% off your first purchase when you join our newsletter.",
    cta_email: "Your email address",
    cta_button: "Sign me up",
    cta_thanks: "Thank you! You're subscribed.",

    // Product
    product_price: "Price",
    product_pages: "pages",
    product_format: "PDF • Instant download",
    product_add_cart: "Add to cart",
    product_in_cart: "In cart",
    product_about: "About this product",
    product_related: "Others also love",

    // Cart
    cart_title: "Your cart",
    cart_empty: "Your cart is empty",
    cart_continue: "Continue shopping",
    cart_subtotal: "Subtotal",
    cart_total: "Total",
    cart_checkout: "Checkout",
    cart_remove: "Remove",
    cart_qty: "Qty",

    // Checkout
    checkout_title: "Complete your order",
    checkout_email: "Email address",
    checkout_email_help: "We'll send the PDFs to this address",
    checkout_name: "Name (optional)",
    checkout_pay: "Pay now",
    checkout_secure: "Secure payment with Stripe",

    // Success
    success_title: "Thank you!",
    success_sub: "Your order is confirmed",
    success_email: "We've sent download links to:",
    success_download: "Download your products",
    success_continue: "Back to the shop",
    success_processing: "Processing payment...",
    success_failed: "Something went wrong. Please try again.",

    // Footer
    footer_tagline: "Beautiful digital resources for everyday life",
    footer_quick: "Quick links",
    footer_legal: "Legal",
    footer_privacy: "Privacy",
    footer_terms: "Terms",
    footer_refund: "Refunds",
    footer_rights: "All rights reserved",

    // Chat
    chat_title: "Hi! Can I help you?",
    chat_placeholder: "Type a message...",
    chat_send: "Send",
    chat_welcome: "Hi! I'm the Småstund assistant. How can I help you today?",

    // Categories
    cat_smabarn: "Toddlers",
    cat_skolebarn: "School Children",
    cat_aktiviteter: "Activities",
    cat_oppskrifter: "Meal Plans",
    cat_tospraklig: "Bilingual",
    cat_foreldre: "Parenting",
    cat_all: "All",

    // Bundles
    bundles_eyebrow: "Save with bundles",
    bundles_title: "Resources in bundles — great deals",
    bundles_sub: "Curated to save you time and money",
    bundle_save: "Save",
    bundle_includes: "Includes",
    bundle_products: "products",
    bundle_value: "Value",
    bundle_view_all: "See all bundles",
    bundle_add_cart: "Add bundle to cart",
    bundle_in_cart: "Bundle in cart",

    // Common
    loading: "Loading...",
    currency: "NOK",
  },
};
